<template>
  <DashboardCard ref="dashboardCard" :class="['mb-3 w-100 auto-h' ,{'ml-2': !checkMobile(768)}]">
    <div class="d-flex align-items-center justify-content-center" v-if="activeLoad">
      <Loader :visible="activeLoad"></Loader></div>
    <img src="@/assets/folder_arrow.svg" alt="Link" slot="icon" class="card-icon">
    <span slot="title">Material de Apoio</span>

  <div class="wrapper-card-material-de-apoio" v-show="!activeLoad">
    <div v-if="files.length > 0" class="wrapper-material-de-apoio">
      <table class="file-table">
        <thead>
          <th>Nome</th>
          <th v-if="!checkMobile(768)" class="th-modificado">Modificado</th>
          <th class="th-tamanho">Tamanho</th>
          <th class="th-baixar">Baixar</th>
        </thead>
        <tbody>
          <tr v-for="file in files.slice(0, 5)" :key="file.idt">
            <td class="file-name">
              <div class="file-name-folder-icon">
                <img class="folder-icon" src="@/assets/file_types/folder.svg"
                  alt="folder-icon" height="22">
                <router-link
                  @click.native="track(`arquivo campanha ${advertiser.code} ${file.idt}`,
                  `clicou material de apoio ${advertiser.code} ${file.idt}`), setBreadCrumb(file.file_name,file.idt)"
                  class="file-name-link"
                  :to="listFilesUrl+file.file_name.replace(/\s/g, '-')+ '/' +file.idt">
                  <span class="text-regular">{{ titleFormatter(file.file_name) }}</span>
                </router-link>
              </div>
              <span class="modificado-text" v-if="checkMobile(768)">
                Modificado {{ dateFormatter(file.created_at) }}
              </span>
            </td>
            <td v-if="!checkMobile(768)">
              <span class="text-regular">{{ dateFormatter(file.created_at) }}</span>
            </td>
            <td class="file-size">
              <span class="text-regular">{{ file.file_size || '0 KB' }}</span>
            </td>
            <td class="file-download">
              <a href="#" @click.prevent="callZipFiles(file);
              track(`download ${file.file_name} ${advertiser.code}`, `clicou pasta ${file.file_name} ${advertiser.code}`);">
                <img src="@/assets/download.svg" alt="download-icons" class="download-icon">
                 <span class="text-regular" v-if="!checkMobile(768)">Download</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="no-files" v-else>
      <span class="text-neutral">Aguarde material de apoio em breve.</span>
    </div>
  </div>

    <div class="ver-mais" v-show="files.length > 5">
      <router-link
        @click.native="track(`ver mais material de apoio ${advertiser.code}`,
        `clicou material de apoio ${advertiser.code}`)"
        class="ver-mais-button" :to="listFilesUrl">
          Mais material de apoio
      </router-link>
    </div>
  </DashboardCard>
</template>

<script>
import FilesApi from '@/services/fileManager';
import DashboardCard from '@/components/DashboardCard';
import { getStringFromDate } from '@/utils/dateUtils';
import { truncateString } from '@/utils/stringUtils';
import zipFiles from '@/services/zipFiles';

import Loader from '@/components/Loader';

export default {
  name: 'filesCard',
  props: ['advertiser'],
  components: {
    DashboardCard,
    Loader,
  },
  data() {
    return {
      files: [],
      activeLoad: true,
    };
  },
  async created() {
    const { folders } = await FilesApi.getFoldersByIdtProductSource(this.advertiser.id);
    this.activeLoad = false;
    this.files = folders;
  },
  computed: {
    listFilesUrl() {
      return `/campanha/${this.advertiser.code}/material-de-apoio/`;
    },
  },
  methods: {
    dateFormatter(value) {
      return getStringFromDate(new Date(value));
    },
    titleFormatter(title) {
      return truncateString(title, 22);
    },
    checkMobile(size) {
      return (window.innerWidth <= size);
    },
    setBreadCrumb(breadName, breadIdt) {
      const bread = [
        { name: 'Campanhas', url: '/campanhas' },
        { name: this.advertiser.name, url: `/campanha/${this.advertiser.code}` },
        { name: 'Material de apoio', url: `/campanha/${this.advertiser.code}/material-de-apoio` },
        { name: breadName, url: `/campanha/${this.advertiser.code}/material-de-apoio/${breadName}/${breadIdt}`, idt: breadIdt },
      ];
      sessionStorage.setItem('pag.material.breadcrumb', JSON.stringify(bread));
    },
    async callZipFiles(file) {
      await zipFiles(file);
    },
  },
};
</script>

<style lang="scss" scoped>
  .wrapper-card-material-de-apoio{
    height: 100%;
    width: 100%;
    display: flex;
  }

  .auto-h {
    height: inherit !important;
  }

  .card-icon {
    margin-top: 4px;
  }

  .file-name-link {
    color: black;
  }

  .file-table {
    width: 100%;
    padding: 6px 0px;

    tr {
      padding: 0 10px;
    }

    th {
      font-size: 14px;
      padding-bottom: 8px;
      border-bottom: solid 1px #CDCDCD;
    }

    tbody {
      padding-top: 10px;

      td {
        padding: 6px 0px;
      }
    }
  }

  .modificado-text{
    font-size: 12px;
    text-align: left;
  }

  .folder-icon {
    padding-right: 6px;
  }

  .ver-mais{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 38px;

    .ver-mais-button{
      border: 1px solid $denim;
      color: $denim;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 70px;
      height: 38px;
      @include text-size-regular();
    }
  }

  .no-files {
    display: flex;
    min-height: 80px;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .download-icon {
    padding-right: 3px;
    height: 20px;
  }

  .wrapper-material-de-apoio{
    display: flex;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding-bottom: 20px;
  }

  .loading-bar, .loading-placeholder::before {
    -webkit-animation: 'loading-bar' 2s infinite !important;
  }

@media (max-width: 768px) {
  .download-icon {
    height: 25px;
  }
  .th-tamanho, .th-baixar, .file-size, .file-download {
    text-align: center;
  }
  .file-name {
    line-height: 14px;
  }
  .file-name-folder-icon {
    display: flex;
    height: 22px;
    align-items: center;
  }
}

/deep/ {
  .icon {
    display: flex;
    @media screen and (max-width: $lg) {
      padding-top: 8px;
    }
  }
}
</style>
